<template>
  <FilterFoundation
    :active="isActive"
    :label="label"
    :disabled="disabled"
    role="button"
    tabindex="0"
    :aria-disabled="disabled"
    :data-active="isActive"
    @click="handleClick"
    @keydown.space.enter="handleClick"
  >
    <template #left-slot>
      <BadgeCounterFoundation
        v-if="isActive"
        class="badge-count"
        :value="selectedCounter"
        :active="true"
        :disabled="disabled"
        size="small"
        data-testid="filter-select-counter"
      />
      <BaseIcon
        v-else
        icon="ic_filter_list"
        data-testid="filter-select-icon"
        width="20px"
        height="20px"
      />
    </template>
    <template v-if="showChevronIcon" #right-slot>
      <BaseIcon icon="ic_chevron_down" width="20px" height="20px" />
    </template>
  </FilterFoundation>
</template>

<script lang="ts">
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import {
  FilterFoundation,
  BadgeCounterFoundation,
  BaseIcon
} from '@warrenbrasil/nebraska-web';

@Component({
  components: {
    FilterFoundation,
    BadgeCounterFoundation,
    BaseIcon
  }
})
export default class FilterSelectButton extends Vue {
  @Prop({ type: Number, default: 0, required: false })
  readonly selectedCounter!: number;

  @Prop({ type: String, required: true })
  readonly label!: string;

  @Prop({ type: Boolean, required: false, default: false })
  readonly disabled!: boolean;

  @Prop({ type: Boolean, required: false, default: true })
  readonly showChevronIcon!: boolean;

  @Emit('click')
  emitClickEvent() {}

  get isActive() {
    return this.selectedCounter > 0;
  }

  handleClick() {
    if (this.disabled) return;
    this.emitClickEvent();
  }
}
</script>
<style lang="less" scoped>
.badge-count {
  background-color: transparent;
  color: @base-primary;
  margin-right: @size-spacing-x150;
}
</style>
